import React, { useMemo } from 'react'
import { connect } from 'react-redux';
import { add as addToCart } from '../Actions/Cart.action'

import { tcEventProductListView, tcEventProductClickEvent } from '../Actions/TagCommander.action'
import ProductCard from './ProductCard';
import MultiCarousel from './MultiCarousel'

const carouselSettings = {
    responsive: {
        smallScreen: {
            breakpoint: {max: 550, min: 0},
            items: 1,
            paritialVisibilityGutter: 50,
            slidesToSlide: 1
        },
        mediumScreen: {
            breakpoint: {max: 764, min: 550},
            items: 2,
            paritialVisibilityGutter: 0,
            slidesToSlide: 2
        },
        largeScreen: {
            breakpoint: {max: 1024, min: 764},
            items: 2,
            paritialVisibilityGutter: 50,
            slidesToSlide: 2
        },
        xLargeScreen: {
            breakpoint: {max: 1124, min: 1024},
            items: 3,
            paritialVisibilityGutter: 0,
            slidesToSlide: 3
        },
        xXLargeScreen: {
            breakpoint: {max: 1400, min: 1124},
            items: 3,
            paritialVisibilityGutter: 50,
            slidesToSlide: 3
        },
        xXXLargeScreen: {
            breakpoint: {max: 9999, min: 1400},
            items: 4,
            paritialVisibilityGutter: 0,
            slidesToSlide: 4
        },
    }   
}

const ProductListSlider = (({ heading, text, products, tcProducts, addToCart }) => {
    function handleSetDisplayedProducts (startItem, endItem) {
        if (startItem == 0) return

        startItem = startItem - 1   // reposition to handle zero based index
        endItem = endItem - startItem // calculate the number of items to display
        const filteredTcProducts = [...tcProducts].splice(startItem, endItem)

        filteredTcProducts && tcEventProductListView(filteredTcProducts)
    }

    function handleClickProduct(product) {
        const clickedTcProduct = tcProducts
            .find(tcProduct => 
                tcProduct.productID == product.reference 
                || tcProduct.productName == product.title
            )

        if (!clickedTcProduct) return

        tcEventProductClickEvent(clickedTcProduct, heading)
    }

    const MemoMultiCarousel = useMemo(() => MultiCarousel)

    return (        
        products.length > 0 && (
            <MemoMultiCarousel {...{ carouselSettings, heading, text, setDisplayedItems: handleSetDisplayedProducts }}>
                {
                    products.map((product, key) => (
                        <ProductCard 
                            key={key} 
                            onClick={(product) => handleClickProduct(product)} 
                            {...{ product, theme: null, addToCart }} />
                    ))
                }
            </MemoMultiCarousel>
        )
    )
})

const mapDispatchToProps = dispatch => {
    return {
        addToCart: (buttonDomNode, articleNumber) => {
            dispatch(addToCart({ 
                articleNumber, 
                quantity: 1,
                hash: Date.now(),
            }));
        }
    }
}

export default connect(null, mapDispatchToProps)(ProductListSlider);